// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"09b51e43","156":"0a2a3ad8","453":"48b318b7","506":"19a3edf7","516":"cae0a8b4","532":"54f62770","554":"129b4c25","567":"b024a5d3","621":"a22e6bb2"}[chunkId] + ".chunk.js";
};